/**
 * src/lib/resolveRestoreTab.js
 *
 * TICKET-019 Phase 2 — pure resolver mapping a chunk-reload breadcrumb's
 * `from_view` label (e.g. "Pipeline", "Planner") back to a VIEW_REGISTRY
 * tab key (e.g. "pipeline", "tasks"). Used by AppShell on mount to restore
 * the user's prior view after an auto-reload, instead of dumping them on
 * the Focus default.
 *
 * Pure function so it can be unit-tested without booting AppShell. Only the
 * registry's { tabKey: { label } } shape is consumed — no React, no DOM.
 */

/**
 * @param {{ from_view?: string|null } | null | undefined} breadcrumb
 * @param {Record<string, { label: string }>} registry  e.g. VIEW_REGISTRY
 * @returns {string|null}  tabKey to restore, or null if none / unmappable
 */
export function resolveRestoreTab(breadcrumb, registry) {
  if (!breadcrumb || !breadcrumb.from_view) return null;
  if (!registry || typeof registry !== 'object') return null;
  const target = String(breadcrumb.from_view).trim();
  if (!target) return null;
  for (const [tabKey, entry] of Object.entries(registry)) {
    if (entry && entry.label === target) return tabKey;
  }
  return null;
}
